// F4-11 NAW-verplichting bij ondertekenen.
//
// Vast, niet-coach-bewerkbaar tekstblok dat vóór de per-abonnementstype
// overeenkomsttekst wordt geplakt — zelfde patroon als de SEPA-
// machtigingstekst (web/src/utils/sepaMachtigingText.js): één tekstblok,
// niet per zinsdeel via i18n-sleutels. Servertwin staat in
// supabase/functions/sign-agreement/index.ts (buildNaamAdresVerklaringText,
// autoritatief voor PDF/agreement_text).

const NAW_VERKLARING_TEMPLATE = `Ondergetekende, {KLANT_NAAM}, wonende te {KLANT_POSTCODE} {KLANT_PLAATS} ({KLANT_STRAAT} {KLANT_HUISNUMMER}), verklaart hierbij onderstaande overeenkomst te zijn aangegaan en akkoord te gaan met de daarin genoemde voorwaarden.`;

/**
 * Vult de NAW-verklaring in. Ontbrekende gegevens renderen als duidelijke
 * placeholder i.p.v. te crashen (komt in de praktijk niet voor: de
 * ondertekenknop is uitgeschakeld totdat deze velden gevuld zijn).
 *
 * @param {object} params
 * @param {string} params.klantNaam
 * @param {string} [params.klantStraat]
 * @param {string} [params.klantHuisnummer]
 * @param {string} [params.klantPostcode]
 * @param {string} [params.klantPlaats]
 */
export function buildNaamAdresVerklaringText({
  klantNaam,
  klantStraat,
  klantHuisnummer,
  klantPostcode,
  klantPlaats,
}) {
  return NAW_VERKLARING_TEMPLATE
    .replace(/\{KLANT_NAAM\}/g, klantNaam || '[naam onbekend]')
    .replace(/\{KLANT_STRAAT\}/g, (klantStraat || '').trim() || '[straat onbekend]')
    .replace(/\{KLANT_HUISNUMMER\}/g, (klantHuisnummer || '').trim() || '[huisnummer onbekend]')
    .replace(/\{KLANT_POSTCODE\}/g, (klantPostcode || '').trim() || '[postcode onbekend]')
    .replace(/\{KLANT_PLAATS\}/g, (klantPlaats || '').trim() || '[woonplaats onbekend]');
}
